import React from "react";

export const VitrineContext = React.createContext({
    articles:[], filters:{}, price_range:{min:0,max:0},page:1,histogrm:[]
});